export default "__VITE_ASSET__39aff938__"